import {vars} from "../../../vars.js";

export const footer = ()=> {

    const section = document.querySelector('.footer');
    if(section){
        const func = () => {
            if((window.innerHeight - vars.header.scrollHeight) <= section.offsetHeight){
                document.body.style.paddingBottom = '';
                section.classList.add('static');
            } else {
                setTimeout(() => {
                    document.body.style.paddingBottom = `${section.offsetHeight}px`;
                    section.classList.remove('static');
                }, 1100)
            }
        }
        func();
        window.addEventListener('resize', () => {
            if (!navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
                func();
            }
        });
        window.addEventListener('orientationchange', () => {
            func();
        });
    }

}